import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend
);

export const GenericChart = <TType extends 'line' | 'bar'>({
  type,
  data,
  options,
  height
}: {
  type: TType;
  data: ChartData<TType, number[], string>;
  options: ChartOptions;
  height: number;
}) => {
  if (type === 'line') {
    return (
      <Line
        height={height}
        data={data as ChartData<'line', number[], string>}
        options={options as ChartOptions<'line'>}
      />
    );
  }
  return (
    <Bar
      height={height}
      data={data as ChartData<'bar', number[], string>}
      options={options as ChartOptions<'bar'>}
    />
  );
};
